import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'de',
    fullName: 'German',
    nativeName: 'Deutsch',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Es kommt etwas Erstaunliches",
    landing_subtitle: "ArgVoid ist ein App- und Spieleentwicklungsstudio. Bleiben Sie dran, bald gibt es Neues!",
    select_language: "Wählen Sie Sprache aus",
    search_placeholder: "Sprachen suchen...",
    terms_title: "Nutzungsbedingungen",
    policy_title: "Datenschutzrichtlinie",
    cookies_title: "Cookie-Richtlinie",
    terms_content: `
        <strong>1. Annahme der Bedingungen</strong><br>
        Durch den Zugriff auf ArgVoid werden diese Nutzungsbedingungen akzeptiert. Wenn diesen Bedingungen nicht zugestimmt wird, sollte der Dienst nicht genutzt werden.<br><br>

        <strong>2. Plattformnutzung</strong><br>
        ArgVoid und seine Anwendungen werden „wie besehen“ zu Informations- und kreativen Zwecken bereitgestellt. Der Dienst darf nur für rechtmäßige Zwecke genutzt werden.<br><br>

        <strong>3. Verbotenes Verhalten</strong><br>
        Das Ausnutzen von Schwachstellen auf der Website, Spam oder der Versuch, unbefugt auf die Infrastruktur zuzugreifen, ist strengstens untersagt.<br><br>

        <strong>4. Haftungsausschluss</strong><br>
        Die Plattform und die Dienste können jederzeit und ohne Vorankündigung geändert werden. Es wird keine Garantie hinsichtlich der Betriebszeit oder Verfügbarkeit des Dienstes übernommen.
    `,
    policy_content: `
        <strong>1. Informationssammlung</strong><br>
        Die Plattform erfordert derzeit keine Benutzerauthentifizierung oder Kontoerstellung. Es werden keine personenbezogenen Daten (wie Namen oder E-Mail-Adressen) aktiv von Besuchern erfasst.<br><br>

        <strong>2. Verwendungsdaten</strong><br>
        Es können grundlegende, anonymisierte Analysen erfasst werden, um den Website-Verkehr zu verstehen und die Anwendungen zu verbessern. Diese Daten werden nicht mit individuellen Nutzeridentitäten verknüpft.<br><br>

        <strong>3. Dienste Dritter</strong><br>
        Für Hosting- und Analysedienste können Drittanbieter eingesetzt werden. Die Datenschutzpraktiken dieser jeweiligen Anbieter regeln die auf ihrer Infrastruktur verarbeiteten anonymen Daten.<br><br>

        <strong>4. Datensicherheit</strong><br>
        Zum Schutz der Plattform werden angemessene Sicherheitsmaßnahmen implementiert. Allerdings ist keine Übertragungsmethode über das Internet völlig sicher.<br><br>
    `,
    cookies_content: `
        <strong>1. Was sind Cookies und lokaler Speicher?</strong><br>
        Bei Cookies und Browser Local Storage handelt es sich um kleine Datendateien, die auf dem Gerät gespeichert werden, um Konfigurationseinstellungen bei allen Besuchen zu speichern.<br><br>

        <strong>2. Verwendungszweck</strong><br>
        Browser LocalStorage wird ausschließlich zum Speichern von Konfigurationseinstellungen verwendet, z. B. <br>
        - Spracheinstellungen<br>
        - Konfiguration der Benutzeroberfläche (z. B. Layout- oder Designeinstellungen)<br>
        - Temporärer Anwendungscache<br><br>

        <strong>3. Kein Tracking</strong><br>
        Cookies und lokale Speicherung werden nicht für Werbe- oder Trackingzwecke durch Dritte verwendet. Alle gespeicherten Daten dienen ausschließlich der Kernfunktionalität der Plattform.<br><br>

        <strong>4. Steuerung</strong><br>
        Browserdaten können jederzeit über die Browsereinstellungen gelöscht werden, wodurch alle lokalen Konfigurationen zurückgesetzt werden.
    `,
    cookie_consent_text: "Wir verwenden grundlegende Cookies, um sicherzustellen, dass die Website ordnungsgemäß funktioniert, z. B. um Ihre Sitzung aktiv zu halten, Ihre Spracheinstellungen zu speichern und andere benutzerdefinierte Konfigurationen vorzunehmen.",
    read_policy: "Lesen Sie die Cookie-Richtlinie",
    support_title: "Kontaktieren Sie den Support",
    support_subject_label: "Thema",
    support_message_label: "Nachricht",
    support_submit_button: "Nachricht senden",
    support_hint: "Hinweis: Dadurch wird Ihre Standard-E-Mail-Anwendung zum Senden der Nachricht geöffnet.",
    support_success_msg: "Öffnen Sie Ihre E-Mail-App...",
    support_error_msg: "Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es später noch einmal.",
    explorer_title: "Forscher",
    history_title: "Geschichte",
    animation_title: "Animation",
    config_title: "Konfiguration",
    tool_mouse: "Auswählen (Strg+M)",
    tool_brush: "Pinsel (Strg+B)",
    tool_brush_mode: "Umschaltmodus (fest/klar)",
    tool_eraser: "Radiergummi (Strg+E)",
    tool_brush_size: "Passen Sie die Pinselgröße an",
    tool_bucket: "Füllen (Strg+F)",
    tool_eyedropper: "Pipette",
    tool_grid: "Raster (Strg+Umschalt+B)",
    tool_rotate: "Drehen (Strg+Umschalt+R)",
    tool_flip_h: "H umdrehen (Strg+Umschalt+H)",
    tool_flip_v: "V umdrehen (Strg+Umschalt+V)",
    tool_transpose: "Transponieren (Strg+Umschalt+T)",
    label_width: "Breite",
    label_height: "Höhe",
    label_frames: "Anzahl der Frames",
    label_animation: "Animationsstil",
    label_background_color: "Hintergrundfarbe",
    label_interval: "Intervall",
    tool_anim_config: "Animationskonfiguration",
    label_new_width: "Neue Breite",
    label_new_height: "Neue Höhe",
    label_apply: "Anwenden",
    label_colors: "Farben",
    label_size: "Größe",
    label_tolerance: "Toleranz",
    val_horizontal: "Horizontal",
    val_vertical: "Vertikal",
    val_sequence: "Sequenz",
    val_bounce: "Prallen",
    val_random: "Zufällig",
    val_solid: "Solide",
    val_clear: "Klar",
    action_add_sheet: "Neues Blatt",
    action_import: "Import",
    action_export: "Export",
    action_sort_projects: "Sortieren",
    sort_date_old: "Älteste zuerst",
    sort_date_new: "Das Neueste zuerst",
    sort_name_az: "Name (A-Z)",
    sort_name_za: "Name (Z-A)",
    action_new_sprite: "Neues Sprite",
    action_new_project: "Neues Projekt",
    modal_save_all_title: "Alle Änderungen speichern",
    modal_save_all_desc: "Wählen Sie die zu speichernden Assets aus:",
    modal_save_selected: "Ausgewählte speichern",
    action_saved: "Gespeichert",
    modal_create_sprite_title: "Neues Sprite erstellen",
    modal_create_project_title: "Neues Projekt erstellen",
    modal_add_sheet_title: "Neues Blatt hinzufügen",
    modal_rename_sheet_title: "Blatt umbenennen",
    modal_rename_sprite_title: "Sprite umbenennen",
    modal_delete_sprite_title: "Sprite löschen",
    modal_delete_project_title: "Projekt löschen",
    modal_delete_sheet_title: "Blatt löschen",
    placeholder_sprite_name: "Name",
    placeholder_project_name: "Name",
    placeholder_sheet_name: "Name",
    placeholder_new_name: "Neuer Name",
    action_create: "Erstellen",
    action_add: "Hinzufügen",
    action_rename: "Umbenennen",
    action_duplicate: "Duplikat",
    action_delete: "Löschen",
    action_cancel: "Stornieren",
    confirm_delete_sprite: "Sind Sie sicher, dass Sie dieses Sprite löschen möchten?",
    confirm_delete_project: "Möchten Sie dieses Projekt wirklich löschen? Alle Sprites werden entfernt.",
    confirm_delete_sheet: "Sind Sie sicher, dass Sie dieses Blatt löschen möchten?",
    err_select_sprite: "Bitte wählen Sie zuerst ein Sprite aus.",
    err_select_project: "Bitte wählen Sie zunächst ein Projekt aus.",
    err_name_empty: "Der Name darf nicht leer sein.",
    err_sprite_exists: "Ein Sprite mit diesem Namen existiert bereits.",
    err_project_exists: "Ein Projekt mit diesem Namen existiert bereits.",
    err_no_content: "Kein Inhalt zum Speichern vorhanden.",
    err_no_changes: "Keine Änderungen zum Speichern.",
    err_delete_last_sheet: "Das letzte Blatt kann nicht gelöscht werden.",
    err_extract_frames: "Es konnten keine Frames extrahiert werden.",
    err_indexeddb: "Lokales Speichern fehlgeschlagen. Ihr Browser unterstützt IndexedDB möglicherweise nicht.",
    msg_upload_success: "Hochladen erfolgreich: {0}",
    msg_upload_failed: "Hochladen fehlgeschlagen: {0}",
    msg_save_success: "Speichern erfolgreich.",
    msg_saving: "Sparen...",
    msg_multi_save_result: "{0} Assets gespeichert. {1} Fehler.",
    menu_title: "Speisekarte",
    menu_save: "Speichern",
    menu_save_all: "Alles speichern",
    menu_support: "Kontaktieren Sie den Support",
    label_local_storage: "Lokaler Speicher",
    label_sign_in: "Anmelden",
    modal_export_title: "Sprite exportieren",
    label_filename: "Dateiname",
    label_format: "Format",
    action_export_confirm: "Export",
};

export default translations;
